// react
import { createContext, Dispatch, SetStateAction } from 'react';

// types
import { StatsGeneral } from '../../../@types';

export interface DashboardFilters {
	fiscalYear: string;
	period: string;
}

export interface ContextDashboardProps {
	filters: DashboardFilters;
	isLoadingGeneral: boolean;
	isLoadingResource: boolean;
	refetchGeneral: () => void;
	refetchResource: () => void;
	setFilters: Dispatch<SetStateAction<DashboardFilters>>;
	statsGeneral: StatsGeneral | null;
	statsResource: StatsGeneral | null;
}

export const ContextDashboard = createContext<ContextDashboardProps>({
	filters: {
		fiscalYear: '',
		period: '',
	},
	isLoadingGeneral: false,
	isLoadingResource: false,
	refetchGeneral: () => {
		console.log('REFETCH GENERAL');
	},
	refetchResource: () => {
		console.log('REFETCH RESOURCE');
	},
	setFilters: () => {
		console.log('SET FILTERS');
	},
	statsGeneral: null,
	statsResource: null,
});
